export default function (context = document) {
  const podcastText = context.getElementById('js-podcastMeta')?.innerText;
  const podcastEl = context.getElementsByClassName('powerpress_player');

  if (podcastText && podcastEl.length) {
    for (const el of podcastEl) {
      el.childNodes[0].title = podcastText; // Anchor link title
      el.childNodes[0].childNodes[0].alt = podcastText; // Anchor link image alt
      el.childNodes[0].childNodes[0].title = podcastText; // Anchor link image title
    }
  }
}
